import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import JobEdit from "./EditJob/JobEdit";

const CallEditJobs = ({ match }) => {

    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <JobEdit jobId={match.params.id} context={"view"} />
        </div>
    );
}

export default CallEditJobs;